import { Api } from '../api';
import {
  RecordCheckInResponse,
  RecordCheckInRequest,
  CustomerLocationUpdateReq,
  CustomerLocationUpdateRes,
  VisitsRequest,
  VisitsV2Res,
} from './visit-model';

export const visitApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getVisits: builder.query<VisitsV2Res[], VisitsRequest>({
      query: ({ sellerWorkspaceId, ...args }) => {
        const newArgs = { ...args, random: Math.random() };
        return {
          url: `hub/reports/api/v1/analytics/salesmen-detail-report`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: newArgs,
        };
      },
    }),
    recordVisit: builder.mutation<RecordCheckInResponse, RecordCheckInRequest>({
      query: (args) => {
        return {
          url: `hub/orgs/api/visit/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
    customerLocationUpdate: builder.mutation<
      CustomerLocationUpdateRes,
      CustomerLocationUpdateReq
    >({
      query: (args) => {
        return {
          url: `hub/orgs/api/visit/${args.visitId}`,
          method: 'PUT',
          body: args.body,
          params: { sellerWorkspaceId: args.sellerWorkspaceId },
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useLazyGetVisitsQuery,
  useGetVisitsQuery,
  useRecordVisitMutation,
  useCustomerLocationUpdateMutation,
} = visitApi;
